import { ValueFormatterParams } from "ag-grid-community";
import { formatNumber } from "../../../utils/format/formatNumber";

export function integerFormatter(params: ValueFormatterParams): string {
  return formatNumber(params?.value, 0);
}
